<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <label class="col-form-label text-primary">Por</label>
                </div>

                <div class="col-auto">
                    <select @change="Lista" v-model="Filtro.IdArticuloCategoria" class="form-select form-control-search">
                        <option value="">Todas las categorías</option>
                        <option v-for="(item,index) in Categorias" :key="index" :value="item.IdArticuloCategoria">{{item.Nombre}}</option>
                    </select>
                </div>

                <div class="col-auto">
                    <select @change="Lista" v-model="Filtro.TipoMaterial" class="form-select form-control-search">
                        <option value="distinto">Todos los tipos</option>
                        <option value="Material">Material</option>
                        <option value="Herramienta">Herramienta</option>
                        <option value="Insumo">Insumo</option>
                    </select>
                </div>
            </template>

			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Categoría</th>
                <th :class="StyleTh">Stock</th>
                <th :class="StyleTh">Existencias</th>
                <th :class="StyleTh">Tipo de Material</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{lista.Nombre}}</h6></td>
                    <td><p :class="StyleTd">{{lista.articulo_categoria.Nombre}}</p></td>
                    <td><p :class="StyleTd">{{lista.Stock}}</p></td>
                    <td><p :class="StyleTd">{{lista.Stock}}</p></td>
                    <td><p :class="StyleTd">{{lista.TipoMaterial}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdArticuloAlmacen" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                                <CMoreButtonsL>
							        <template slot="bodyBtnsL">
                                        <template v-if="lista.TipoMaterial !='Galeria' && segurity.ViewSection">
                                            <li @click="IrAPresentaciones(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-person-carry"></i> Ver Presentaciones
                                                </a>
                                            </li>
                                        </template>

                                        <template v-if="segurity.UpdateStock">
                                            <li @click="CambiarStock(lista)">
                                                <a class="dropdown-item">
                                                    <i class="far fa-clipboard-check"></i> Cambiar Stock
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                </CMoreButtonsL>
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="7"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>

        <CModal :pConfigModal="ConfigModalStock" :poBtnSave="oBtnSaveStock">
			<template slot="Form">
				<FormStock :poBtnSave="oBtnSaveStock"></FormStock>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/modulos/almacen/material/Form.vue';
import FormStock from '@/views/modulos/almacen/material/StockForm.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionMaterial';
const EmitEjecutaStock = 'seccionStock';

export default {
    name: 'ListaMaterial',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        FormStock
    },
    data() {
        return {
            ConfigList:{
                Title: 'Inventario',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Almacen',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdArticuloCategoria:"",
                TipoMaterial: 'distinto',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario de Materiales",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },

            // SEGUNDO MODAL
            ConfigModalStock:{
                ModalTitle: "Cambiar Stock",
                ModalNameId: 'Stock',
                EmitSeccion: EmitEjecutaStock,
            },
            oBtnSaveStock: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecutaStock,
                ShowSpinner:false
            },

            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Categorias:[],
            Material:{}
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("articulosAlmacen",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdArticuloCategoria: this.Filtro.IdArticuloCategoria,
                    TipoMaterial: this.Filtro.TipoMaterial,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;

            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('articulosAlmacen/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        IrAPresentaciones(item){
            this.$router.push({name:'presentacion', params:{pObjEnviado:item}});
        },
        CambiarStock(item){
            this.Material = item;
            this.bus.$emit('NewModal_'+this.ConfigModalStock.EmitSeccion, item.IdArticuloAlmacen,item);
        },
        async ListaCategorias()
        {
            await this.$http.get('articulosCategoria', {
                params: {
                    simple: 1,
                    TipoCategoria: 'Producto',
                }
            }).then((res) => {
                this.Categorias = res.data.data;
            });
        }
    },
    created()
    {

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.ListaCategorias();
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
